import { gql, useMutation } from '@apollo/client'
import type { GQL_ID } from '@@partner:types:graphql'

export interface TranslationInput {
  language_code: string
  name?: string
}

export interface GeoPointInput {
  latitude?: number
  longitude?: number
}

export interface CityInput {
  id?: GQL_ID
  name: string
  region_id: GQL_ID
  default_shop_id?: GQL_ID
  geo_point?: GeoPointInput
  i18n?: TranslationInput[]
}

export interface CityTranslation {
  language_code: string
  name?: string
}

export interface GeoPoint {
  latitude?: number
  longitude?: number
  geo_lat?: number
  geo_lon?: number
}

export interface City {
  id: GQL_ID
  name: string
  region_id: GQL_ID
  default_shop_id?: GQL_ID
  defaultGeoPoint?: GeoPoint
  i18n?: CityTranslation[]
}

export interface SaveCityMutation {
  saveCity: City
}

export interface SaveCityVariables {
  cityInput: CityInput
  upsert?: boolean
}

export const GQL_MUTATION_SAVE_CITY = gql`
  mutation saveCity($cityInput: CityInput!, $upsert: Boolean) {
    saveCity(cityInput: $cityInput, upsert: $upsert) {
      id
      name
      region_id
      defaultGeoPoint {
        latitude
        longitude
        geo_lat
        geo_lon
      }
      i18n {
        language_code
        name
      }
    }
  }
`

export const useSaveCity = () =>
  useMutation<SaveCityMutation, SaveCityVariables>(GQL_MUTATION_SAVE_CITY)
